import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

export default function Layout({ user }) {
  return (
    <div className="d-flex">
      <Sidebar user={user} />
      <div className="flex-grow-1 p-3 bg-light">
        <Outlet />
      </div>
    </div>
  );
}